import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { Card, Heading, Stack, Text, textVariants } from '@etg/wings';
import { css } from '@eti/styles';
import { BoundNew } from '@eti/types';
import { CartRow } from '../../cart/components/CartComponents';
import CartTripInfo from '../../cart/components/trip-details/CartTripInfo';
import AddedExtraProducts from './AddedExtraProducts';
import ExtraProducts from './ExtraProducts';
import OrderTotal from './OrderTotal';

const cartTripInfoStyles = css`
  margin-bottom: 0;
`;

const OrderContent = ({
  addedAncillaryBundles,
  addedExtraProducts,
  bounds,
  extraProducts,
  isLoading,
  title,
  totalPrice,
}) => {
  const { t } = useTranslation();

  return (
    <Card data-testid="postBooking-cart">
      {title && (
        <Card.Section>
          <Heading data-testid="postBooking-cart-header" level={2}>
            {title}
          </Heading>
        </Card.Section>
      )}

      {bounds.length > 0 && (
        <Card.Section data-testid="postBooking-cart-bounds">
          <CartTripInfo bounds={bounds} className={cartTripInfoStyles} />
        </Card.Section>
      )}

      {(extraProducts.length > 0 || addedAncillaryBundles?.length > 0) && (
        <Card.Section data-testid="postBooking-cart-extra-products">
          <Stack>
            <Text variant={textVariants._18_EMPHASIZED}>
              {t('Postbooking.Widget.AlreadyBoughtExtraProductsTitle')}
            </Text>
            <ExtraProducts addedAncillaryBundles={addedAncillaryBundles} products={extraProducts} />
          </Stack>
        </Card.Section>
      )}

      <Card.Section data-testid="postBooking-cart-added-extra-products">
        <Stack>
          <Text variant={textVariants._18_EMPHASIZED}>
            {t('Postbooking.Widget.AddedExtraProductsTitle')}
          </Text>
          {addedExtraProducts.length > 0 ? (
            <AddedExtraProducts extraProducts={addedExtraProducts} />
          ) : (
            <CartRow data-testid="postBooking-cart-no-products">
              <Text>{t('Postbooking.ProductPage.NoProductsInCartMessage')}</Text>
            </CartRow>
          )}
        </Stack>
      </Card.Section>

      {addedExtraProducts.length > 0 && (
        <Card.Section data-testid="postBooking-cart-price-summary">
          <Stack>
            <Heading level={3}>{t('Cart.PriceSummary.Header.Label')}</Heading>
            <OrderTotal isLoading={isLoading} totalPrice={totalPrice} />
          </Stack>
        </Card.Section>
      )}
    </Card>
  );
};

OrderContent.propTypes = {
  addedAncillaryBundles: PropTypes.arrayOf(PropTypes.object),
  addedExtraProducts: PropTypes.arrayOf(PropTypes.object),
  bounds: PropTypes.arrayOf(BoundNew),
  extraProducts: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  totalPrice: PropTypes.number,
};

export default OrderContent;
